import React from 'react';

interface Props {
  description: string;
}

const DescriptionWithLinks: React.FC<Props> = ({ description }) => {
  const regex = /@\[(.+?)\]/g; // matches @[Flume] and @[Toro y Moi]

  const parts = description.split(regex);
  // split will return ["Let ", "Flume", " and ", "Toro y Moi", " bring...", ...]

  return (
    <p className="text-[14px] font-normal leading-[130%] text-left">
      {parts.map((part, index) =>
        description.match(regex)?.includes(`@[${part}]`) ? (
          <a
            key={index}
            className="w-full text-[14px] font-normal leading-[130%] text-left text-[#0FF]"
            href="#"
            target="_blank"
            rel="noopener noreferrer">
            {part}
          </a>
        ) : (
          part
        ),
      )}
    </p>
  );
};

export default DescriptionWithLinks;
